import React, { useEffect, useState } from 'react'
import CloudRestroUsers from '../../../services/DatabaseService/CloudRestroUsers';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import userimg from '../../../../src/assets/images/users/user-dummy-img.jpg'

import { Button, Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { formatDateTime } from '../../../Components/Common/FormatDate';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';

const CloudRestroUserdetails = () => {

    const { orgCode } = useParams();

    const [userData, setUserData] = useState();

    const [activeTab, setActiveTab] = useState("1");
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    useEffect(() => {
        const fetchbyOrgCode = async () => {
            try {
                const response = await CloudRestroUsers.getbyOrgCode(orgCode);
                console.log(response);
                setUserData(response);
                // console.log(userData)
            } catch (error) {
                console.log(error);
            }
        };
        fetchbyOrgCode();
    }, []);
    console.log(userData)
    return (
        <div className='page-content'>
            <Row>
                <Col lg={12}>
                    <Card className="mt-n4 mx-0">
                        <div className="bg-warning-subtle">
                            <CardBody className="pb-0 ">
                                <Row className="mb-3">
                                    <div className="col-md">
                                        <Row className="align-items-center g-3">
                                            {/* <div className="col-md-auto"> */}
                                            <div className="avatar-md">
                                                <div className="avatar-title bg-white rounded-circle">
                                                    <img src={userimg} alt="" className="avatar-xs" />
                                                </div>
                                            </div>
                                            {/* </div> */}
                                            <div className="col-md">
                                                <div>
                                                    <h4 className="fw-bold">
                                                        {userData?.name ||
                                                            "Tenant Name Unavailable"}{" "}
                                                    </h4>
                                                    <div className="hstack gap-3 flex-wrap fs-9 text-muted">
                                                        <div>
                                                            <i className="ri-building-line align-bottom me-1 text-muted"></i>{" "}
                                                            {userData?.orgCode}
                                                        </div>
                                                        <div className="vr"></div>
                                                        <div>
                                                            Registered Date :{" "}
                                                            <span className="fw-medium">
                                                                {formatDateTime(userData?.joinedDate)}
                                                            </span>
                                                        </div>
                                                        <div className="vr"></div>
                                                        <div>
                                                            Valid Till :{" "}
                                                            <span className="fw-medium">
                                                                {formatDateTime(userData?.expiryDate)}
                                                            </span>
                                                        </div>
                                                        <div className="vr"></div>
                                                        <div>
                                                            Address :{" "}
                                                            <span className="fw-medium">
                                                                {userData?.address1}
                                                            </span>
                                                        </div>
                                                        <div className="vr"></div>
                                                        <br />
                                                        <div>
                                                            Status :{" "}
                                                            <span
                                                                className={`badge rounded-pill ms-1 ${userData?.isActive
                                                                    ? "bg-success-subtle text-success"
                                                                    : "bg-danger-subtle text-danger"
                                                                    }`}
                                                            >
                                                                {userData?.isActive ? "Active" : "Inactive"}
                                                            </span>
                                                        </div>
                                                        <div className="vr"></div>
                                                        {/* <Link to={`/contactperson`}>
                                <Button color="btn btn-soft-success" className="btn-sm ms-1">
                                  Contact Person
                                </Button>
                              </Link> */}

                                                        {/* <div className="vr"></div>
                                                        <div className="badge  bg-info fs-12">New</div>
                                                        <div className="badge  bg-danger fs-12">High</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>
                                    <div className="col-md-auto">
                                        <div className="hstack gap-1 flex-wrap">
                                            {/* <Link to={`/contactdetails`}> */}
                                            <Button color="btn btn-success" className="btn-sm ms-1 border-0" >
                                            Update Expiry
                                        </Button>
                                            {/* </Link> */}
                                            {/* <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-share-line"></i>
                        </button>
                        <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-flag-line"></i>
                        </button> */}
                                        </div>
                                    </div>
                                </Row>

                                <Nav className="nav-tabs-custom border-bottom-0 " role="tablist">
                                    <NavItem>
                                        <NavLink
                                            className={classNames({ active: activeTab === '1' }, " fw-semibold mx-3")}
                                            onClick={() => { toggleTab('1'); }}
                                            href="#">
                                            Payment Details
                                        </NavLink>
                                    </NavItem>
                                    {/* <NavItem>
                                                <NavLink
                                                    className={classNames({ active: activeTab === '2' }, " fw-semibold me-3")}
                                                    onClick={() => { toggleTab('2'); }}
                                                    href="#">
                                                    Payment Logs
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classNames({ active: activeTab === '3' }, "fw-semibold me-3")}
                                                    onClick={() => { toggleTab('3'); }}
                                                    href="#">
                                                    Grace Period details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classNames({ active: activeTab === '4' }, " fw-semibold")}
                                                    onClick={() => { toggleTab('4'); }}
                                                    href="#">
                                                    Contact Person
                                                </NavLink>
                                            </NavItem> */}
                                </Nav>
                            </CardBody>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default CloudRestroUserdetails
